import React from 'react';

import { AcknowledgementState } from 'utils/api/modules/entities/entities.types';

import { StyledMenuItem, StyledSelect } from '../styles';
import { ACK_STATE_LABELS } from './types';

interface AcknowledgementStateSelectProps {
  value: AcknowledgementState | null;
  onChange: (value: AcknowledgementState) => void;
}

const OPTIONS: AcknowledgementState[] = [
  AcknowledgementState.Pending,
  AcknowledgementState.Acknowledged,
  AcknowledgementState.Cancelled,
];

const AcknowledgementStateSelect: React.FunctionComponent<AcknowledgementStateSelectProps> = ({
  onChange,
  ...props
}) => (
  <StyledSelect {...props} fullWidth onChange={(event) => onChange(event.target.value as AcknowledgementState)}>
    {OPTIONS.map((state) => (
      <StyledMenuItem key={state} value={state}>
        {ACK_STATE_LABELS[state]}
      </StyledMenuItem>
    ))}
  </StyledSelect>
);

export default AcknowledgementStateSelect;
